<template>
  <div class="white-image-box">
    <div v-for="item in items" :key="item.label" class="item">
      <span>{{ item.label }}：</span>
      <div class="box">
        <ImageItem
          v-if="goodsItem[item.value]?.img"
          :item="goodsItem[item.value]"
          @cropper="showVueCropper($event, item.value)" @delete="deleteImage(item.value)"
          @upload="showUploadComponent(item.uploadId, item.value)"
        />
        <UploadImage :id="item.uploadId + goodsItem.index" v-show="!goodsItem[item.value]?.img" :imgFile="imgFile" @upload-image="showVueCropper($event, item.value)" />
      </div>
    </div>
    <a-modal
      class="header-fixed-modal"
      width="900px"
      v-model:visible="visible"
      title="裁剪图片"
      :footer="false"
      style="top: 0"
    >
      <CropperImageModal :aspectRatio="imgFile.type === 'longImage' ? 3/4 : 1" :autoCropArea="imgFile.type === 'longImage' ? 1 : .98" :imgFile="imgFile"
        @cropper="cropperSuccess" @close="visible = false" />
    </a-modal>
  </div>
</template>
<script>
import CropperImageModal from "../vue_cropper"
import ImageItem from "../image_item"
import UploadImage from '../upload_image'
export default {
  components: { ImageItem, UploadImage, CropperImageModal },
  data() {
    return {
      goodsItem: { 
        whiteImage: {},
        longImage: {}
      },
      imgFile: {},
      visible: false,
      items: [
        { 
          label: '白底图',
          uploadId: 'white-image-upload',
          value: 'whiteImage'
        }
      ]
    }
  },
  methods: {
    deleteImage(type){
      this.goodsItem[type] = {}
      this.$message.success("删除图片成功")
    },
    showUploadComponent(id, type) {
      this.imgFile.type = type
      document.querySelector(`#${id + this.goodsItem.index}`).click()
    },
    cropperSuccess(imgUrl) {
      const obj = this.goodsItem[this.imgFile.type]
      const imageElement = new Image()
      obj.img = imgUrl
      imageElement.src = imgUrl
      imageElement.onload = () => {
        obj.width = imageElement.width
        obj.height = imageElement.height
        obj.isUpdate = true
      }
      this.visible = false
      this.$message.success('已成功完成裁剪图片')
    },
    showVueCropper(obj, type) {
      this.visible = true
      this.imgFile = obj
      this.imgFile.type = type
    }
  }
}
</script>
<style scoped lang='less'>
  .white-image-box {
    display: flex;
    padding: .5em;
    .item {
      display: flex;
      align-items: flex-start;
      margin-right: 2em;
    }
  }
</style>